import React, { useState } from 'react';
import { DocumentAttachment } from '@spike/client-model';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import styles from './EditDocument.module.scss';

export interface EditDocumentProps {
    doc: DocumentAttachment;
    value: string;
    isLoading?: boolean;
    onChange: (v: string) => void;
    onClose: () => void;
    onSave: () => void;
}

const EditDocument: React.FC<EditDocumentProps> = ({ doc, value, isLoading, onChange, onClose, onSave }) => {
    const [name, setName] = useState(value);
    const [error, setError] = useState('');
    const loading = isLoading || false;

    const validateName = (value: string): boolean => {
        if (value.trim().length === 0) {
            setError('File name is required');
            return false;
        }
        setError('');
        return true;
    };

    const handleSave = () => {
        if (!validateName(name)) {
            return;
        }

        if (name.trim() === value.trim()) {
            onClose();
            return;
        }

        onSave();
    };

    const handleEnterPressed = () => {
        if (!loading) {
            onSave();
        }
    };

    return (
        <GenericModal
            onClose={onClose}
            footer={
                <div className={styles.footer}>
                    <div className={styles.left}>
                        <Button
                            size="large"
                            className={styles.button}
                            label="Cancel"
                            onClick={onClose}
                            variant="black"
                            disabled={loading}
                        />
                    </div>
                    <div className={styles.left}>
                        <Button
                            label={loading ? 'Saving...' : 'Save'}
                            size="large"
                            className={styles.button}
                            onClick={handleSave}
                            variant="green"
                            isLoading={loading}
                            disabled={loading || value.trim().length === 0}
                        />
                    </div>
                </div>
            }
            className={styles.modal}
        >
            <div className={styles.content}>
                <span className={styles.title}>Edit Name</span>
                <Input
                    id="client-document-name"
                    label="File Name"
                    value={name}
                    onChange={e => onChange(e.target.value)}
                    onEnterPressed={handleEnterPressed}
                    disabled={loading}
                    autoFocus
                    maxLength={100}
                    placeholder="Enter document name"
                />
            </div>
        </GenericModal>
    );
};

export default EditDocument;
